import { ErrorComponentProps } from '@ferreri/minato-error-handler-react';
import {
  ModalFullScreen,
  NotFoundIllustration,
} from '@ferreri/prever-component-lib';

export const PlanVersionNotFoundError = ({
  error,
  hideError,
}: ErrorComponentProps) => {
  const callToPrever = () => window.open(`tel:08000016688`, '_self');
  const reloadPage = () => window.location.reload();

  const handleCallToPrever = () => {
    callToPrever();
    hideError();
  };

  const handleReloadPage = () => {
    reloadPage();
    hideError();
  };

  return (
    <ModalFullScreen
      title="Erro ao carregar plano"
      description="Ocorreu um erro no carregamento dos detalhes do plano. Já estamos trabalhando para resolver. Você pode tentar novamente mais tarde ou falar com um consultor pelo Whatsapp. "
      illustration={<NotFoundIllustration />}
      labelButtonPrimary="Tentar novamente"
      onClickButtonPrimary={handleReloadPage}
      labelButtonSecondary="Falar com consultor pelo Whatsapp"
      onClickButtonSecondary={handleCallToPrever}
      error={error}
    />
  );
};
